import type { SVGProps } from 'react';

interface ConfirmedIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function ConfirmedIcon({ className, ...props }: ConfirmedIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="4.5 4.5 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5ZM15.7578 9.21973C15.534 9.00067 15.1761 8.9998 14.9521 9.21875L10.5156 13.5576C10.5148 13.5583 10.5135 13.5583 10.5127 13.5576L9.04785 12.127C8.82394 11.9083 8.46596 11.9083 8.24219 12.127C8.01133 12.3529 8.01133 12.7252 8.24219 12.9512L10.207 14.874C10.3778 15.0411 10.6505 15.0411 10.8213 14.874L15.7578 10.043C15.9886 9.8171 15.9885 9.44562 15.7578 9.21973Z" fill="currentColor"/>
    </svg>
  );
}
